export const associateById = <T extends { id: number }>(entities: T[]) =>
  Object.fromEntries(entities.map((entity) => [entity.id, entity])) as Record<number, T>;

export const associateByItemId = <T extends { itemId: number }>(entities: T[]) =>
  Object.fromEntries(entities.map((entity) => [entity.itemId, entity])) as Record<number, T>;
